import { APIClient } from '@/infra/network/Snapsnap/APIClient'

export class SnapsnapGatewayBase {
  apiClient: APIClient

  constructor(apiClient: APIClient) {
    this.apiClient = apiClient
  }
}
